import sliceCreator from '../../index.js';
import {CREATE_REPORT} from '../../../constants/index.js';
const _createDamageReportAction = sliceCreator('CREATE_REPORT',CREATE_REPORT, 'post');

const { asyncAction: createDamageReportAction, reducer, clearData: clearCreateDamageReportAction } = _createDamageReportAction;

export default reducer;

export {
    createDamageReportAction,
    clearCreateDamageReportAction
}


